import Component from "../../../../js/assets/component.js"
import Util from "../../../../js/assets/util.js"
import YoutubeAPI from "../../../../js/assets/youtube_api.js"

class BgYoutubeMovie extends Component {
  constructor(el, blockIndex){
    super(el)
  }

  data(){
    return {
      "videoRatio": 0.5625, //16:9
      "apiReady": false,
      "embedDone": false,
      "active": false
    }
  }

  changed(){
    return {
      "apiReady": (val)=>{
        if(val === true && this.$data.embedDone == false){
          this.embedPlayer()
        }
      },
      "embedDone": (val)=>{
        if(this.$data.active === true){
          window.addEventListener("resize", ()=>{
            this.setPlayerSize()
          })
          this.setPlayerSize()
          this.play()

          this.$loading.removeClass("-active")
          this.$loading.addClass("-inActive")
          this.$iframeContainer.removeClass("-inActive")
          this.$iframeContainer.addClass("-active")
        }
      },
      "active": (val)=>{
        if(val === true){
          this.activate()
        }else{
          this.inActivate()
        }
      }
    }
  }

  activate(){
    this.$el.removeClass("-inActive")
    this.$el.addClass("-active")
  }

  inActivate(){
    this.$el.removeClass("-active")
    this.$el.addClass("-inActive")
  }

  play() {
    if (this.player && this.player.playVideo) {
      this.player.playVideo()
    }
  }

  resume() {
    if (this.player && this.player.playVideo) {
      this.player.playVideo()
    }
  }

  pause() {
    if (this.player && this.player.pauseVideo) {
      this.player.pauseVideo()
    }
  }

  stop() {
    if (this.player && this.player.pauseVideo) {
      this.player.pauseVideo()
      this.player.seekTo(0, true)
    }
  }

  embedPlayer(){
    var self = this

    this.videoId = this.$el.attr("data-video-id")
    this.GUID = Util.createGUID()
    this.containerId = "#bgYoutubeMovieContainer"+this.GUID
    this.$movieContainer = this.$el.find(".bgYoutubeMovieContainer div")
    this.$movieContainer.attr("id", this.containerId)

    this.player = new YT.Player(this.containerId, {
      "videoId": this.videoId,
      "hd": 1,
      "playerVars": {
        "rel": 0,
        "wmode": "transparent",
        "autoplay": 0,
        "autohide": 1,
        "controls": 0,
        "showinfo": 0,
        "modestbranding": 0,
        "loop": 1,
        "playlist": this.videoId
      },
      "events": {
        "onReady": ()=>{
          self.player.mute()
          self.player.pauseVideo()
          self.$data.embedDone = true
        },
        "onStateChange": function(e){
          switch(e.data){
            case 0:

              break;
            case 1:

              break;
            case 2:

              break;
          }
        }
      }
    })
  }

  removePlayer(){
    this.player.stopVideo()
    this.player.destroy()
    this.player = null
    delete this.player
  }

  setPlayerSize(){
    let winWidth = $(window).width()
    let winHeight = $(window).height()
    let winRatio = winHeight / winWidth
    let top, left, width, height, marginTop, marginLeft

    if(winRatio > this.$data.videoRatio){
      top = 0
      left = "50%"
      marginLeft = -1 * (winHeight / this.$data.videoRatio)/2
      marginTop = 0
      width = (winHeight / this.$data.videoRatio)
      height = "100%"
    }else{
      top = "50%"
      left = 0
      marginLeft = 0
      marginTop = -1 * (winWidth * this.$data.videoRatio)/2
      width = "100%"
      height = (winWidth * this.$data.videoRatio)
    }

    this.$iframeContainer.css({
      top: top,
      left: left,
      width: width,
      height: height,
      "margin-top": marginTop,
      "margin-left": marginLeft
    })
  }

  mounted() {

    //loading
    this.$loading = this.$el.find(".loading")
    this.$loading.addClass("-active")

    //iframeContainer
    this.$iframeContainer = this.$el.find(".bgYoutubeMovieContainer")
    this.$iframeContainer.addClass("-inActive")

    //load API
    YoutubeAPI.addEventListener("loaded", ()=>{
      this.$data.apiReady = true
    })
    YoutubeAPI.loadAPI()
  }
}

export default BgYoutubeMovie
